<template>
  <div class="swiper-slide accounts-step-operation-step">

    <slot name="background"></slot>

    <div class="flex-row flex-center-y"
      :class="{darkBackground: darkBackground}">

      <div class="step"
           v-show="!hidden">

        <div class="content">
          <slot></slot>
        </div>

        <div class="actions"
          v-if="!hideActions"
        >
          <slot name="actions">
            <AccountsMdcButton
              :name="prevStep"
              class="backButton"
              v-if="(!firstStep && !hideBackButton && !remoteStep) || showBackButton"
              @click="$emit('backButtonPressed')"
              :tabindex="hidden ? -1 : 0"
              >
              {{ bbText }}
            </AccountsMdcButton>
            <div class="divider"></div>
            <AccountsMdcButton
              :inverted="!nextButtonRed"
              :red="nextButtonRed"
              :name="nextStep"
              class="nextButton"
              v-if="(!lastStep && !hideNextButton && !remoteStep) || showNextButton"
              @click="$emit('nextButtonPressed')"
              :tabindex="hidden ? -1 : 0"
              >
              {{ nbText }}
            </AccountsMdcButton>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GettextMixin from '@paiuolo/pai-vue-gettext/mixins/GettextMixin'

import AccountsMdcButton from '../../../../elements/button/accounts/AccountsMdcButton'


export default {
  name: 'AccountsStepOperationStep',
  mixins: [
    GettextMixin
  ],
  components: {
    AccountsMdcButton
  },
  props: {
    firstStep: {
      type: Boolean,
      default: false
    },
    lastStep: {
      type: Boolean,
      default: false
    },
    remoteStep: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: true
    },
    prevStep: {
      type: String,
      default: 'prev_step'
    },
    nextStep: {
      type: String,
      default: 'next_step'
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    backButtonText: {
      type: String,
      default: null
    },
    hideBackButton: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    nextButtonText: {
      type: String,
      default: null
    },
    showNextButton: {
      type: Boolean,
      default: false
    },
    hideNextButton: {
      type: Boolean,
      default: false
    },
    darkBackground: {
      type: Boolean,
      default: false
    },
    nextButtonRed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bbText: this.backButtonText || this.gettext('Back'),
      nbText: this.nextButtonText || this.gettext('Continue')
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../scss/accounts.theme";

.accounts-step-operation-step {
  display: table;
  table-layout: fixed;
  word-break: break-word;
  color: #fff;

  .darkBackground {
    z-index: 3;
    background-color: rgba(0,0,0,0.25);
  }

  .flex-center-y {
    height: 100%;
    width: 100%;
    position: relative;
    display: table-cell;
    vertical-align: middle;
  }

  .step {
    width: 264px;
    margin: auto;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    position: relative;
    z-index: 4;


    .actions {
      width: 100%;
      text-align: center;
      margin-top: 16px;
      box-sizing: border-box;
      overflow: hidden;
      position: relative;
      /*
      @include flexbox();
      @include flex-direction(row);

      align-items: center;
      justify-content: center;
      */
      .separator, .divider {
        /*@include flexbox();
        @include flex(1);*/
        float: left;
      }
      .mdcButton {
        max-width: 50%;
      }
      .backButton {
        float: left;
      }
      .nextButton {
        float: right;
      }
    }
  }

}
</style>